import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { DualAuthService } from '../../services/DualAuthService';

@Component({
  selector: 'app-customer-me',
  standalone: true,
  imports: [CommonModule],
  template: `
    <h2>Customer Profile (/api/User/me)</h2>
    <pre>{{ data | json }}</pre>
  `,
})
export class CustomerMeComponent implements OnInit {
  data: any;
  private loaded = false;
  constructor(private http: HttpClient, private auth: DualAuthService, private router: Router) {}
  ngOnInit(): void {
    this.auth.currentUser$.subscribe(u => {
      if (!u || this.loaded) return;
      if (!this.auth.isCustomer()) {
        this.router.navigate(['/whoami/employee']);
        return;
      }
      this.loaded = true;
      // Use /api/User/me which returns customer in the response for customers
      this.http.get(`${environment.backend.baseUrl}${environment.backend.apiUrl}/User/me`, { withCredentials: true })
        .subscribe({
          next: (response: any) => {
            // Extract customer from the unified response
            this.data = response?.customer || response;
          },
          error: e => this.data = e
        });
    });
  }
}
